<template>
  <v-card width="95%" class="m-auto">
    <v-data-table
      fixed-header
      :headers="headers"
      :items="getTxnNoteDetails"
      hide-default-footer
    />
  </v-card>
</template>

<script>
import paymentService from "@/services/PaymentService/paymentService.js";

export default {
  props: {
    ref_number: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      getTxnNoteDetails: [],
      headers: [
        { text: "Txn Id", value: "txn_id" },
        { text: "status", value: "status" },
        { text: "comments", value: "comments" },
        { text: "Posted by", value: "posted_by" },
        { text: "Posted on", value: "posted_date" },
        { text: "Note from", value: "note_type" },
      ],
    };
  },
  watch: {
    ref_number: {
      immediate: true,
      handler(refNumber) {
        this.getTxnNoteDetails = [];
        if (refNumber !== null && refNumber !== undefined && refNumber !== "") {
          this.getTxnNote(refNumber);
        }
      },
    },
  },
  methods: {
    async getTxnNote(refNumber) {
      try {
        const response = await paymentService.getTxnNote(refNumber);
        if (this.ref_number !== refNumber) return;

        this.getTxnNoteDetails =
          response && response.data.status_code === 200 &&
          Array.isArray(response.data.data)
            ? response.data.data
            : [];
      } catch (error) {
        if (this.ref_number === refNumber) this.getTxnNoteDetails = [];
        console.error(error);
      }
    },
  },
};
</script>
